import React, { useState } from "react";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import * as yup from "yup";
import { EditCompetition } from "../../../pages";
import { CompetitionController } from "../../../controllers";

const EditCompetitionContainer = ({ closeModal, selectedCompetition }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object({
    winningAmount: yup
      .number()
      .required("Winning amount is required")
      .positive("Winning amount must be a positive number"),

    name: yup
      .string()
      .required("Name is required")
      .min(3, "Name must be at least 3 characters")
      .max(100, "Name must be at most 100 characters"),

    subTitle: yup.string().required(),
    instagramLink: yup.string().url("Invalid Instagram link format").required(),

    twitterLink: yup.string().url("Invalid Twitter link format").required(),

    registrationStartDate: yup
      .date()
      .required("Registration start date is required"),

    registrationEndDate: yup
      .date()
      .required("Registration end date is required"),
    stageOneVotingStartDate: yup
      .date()
      .required("Stage one voting start date is required"),
    stageTwoVotingStartDate: yup
      .date()
      .required("Stage two voting start date is required"),
    stageTwoVotingEndDate: yup
      .date()
      .required("Stage two voting end date is required"),
    stageOneVotingEndDate: yup
      .date()
      .required("Stage one voting end date is required"),
    description: yup
      .string()
      .required("Description is required")
      .min(100, "Description must be at least 110 characters"),
    summary: yup
      .string()
      .required("Summary is required")
      .min(5, "Summary must be at least 5 characters")
      .max(200, "Summary must be at most 200 characters"),

    currencyCode: yup
      .string()
      .required("Currency code is required")
      .length(3, "Currency code must be exactly 3 characters"),
    status: yup.string().required("Select Competition status"),
    prizes: yup
      .array()
      .of(
        yup.object().shape({
          prize: yup
            .number()
            .required("Prize number is required")
            .min(1, "Prize number must be at least 1"),
          title: yup
            .string()
            .required("Title is required")
            .max(100, "Title cannot exceed 100 characters"),
          prizeKey1: yup.string().required("Prize Key 1 is required"),
          prizeKey2: yup.string(),
          prizeKey3: yup.string(),
          prizeValue1: yup.string().required("Prize Value 1 is required"),
          prizeValue2: yup.string(),
          prizeValue3: yup.string(),
        })
      )
      .min(1, "At least one prize is required")
      .required("Prizes are required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      winningAmount: values.winningAmount,
      name: values.name,
      registrationStartDate: values.registrationStartDate,
      registrationEndDate: values.registrationEndDate,
      stageOneVotingStartDate: values.stageOneVotingStartDate,
      stageTwoVotingStartDate: values.stageTwoVotingStartDate,
      stageTwoVotingEndDate: values.stageTwoVotingEndDate,
      stageOneVotingEndDate: values.stageOneVotingEndDate,
      description: values.description,
      summary: values.summary,
      referrers: ["COMPETITION"],
      currencyCode: values.currencyCode,
      status: values.status,
      subTitle: values.subTitle,
      instagramLink: values.instagramLink,
      twitterLink: values.twitterLink,
      prizes: values.prizes.map(({ _id, ...rest }) => rest),
    };
    const { status, errorMessage } =
      await CompetitionController.editCompetition(
        payload,
        selectedCompetition._id
      );
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];

  return (
    <EditCompetition
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
      selectedCompetition={selectedCompetition}
    />
  );
};
export default EditCompetitionContainer;
